import React from "react";

export const RichTextRender = ({ content }) => {

  try {

  if (!content) return null;

  const renderTextWithMarks = (child, i) => {
    let textNode = child.text;

    if (!textNode) return null;

    let element = textNode;

    // Inline code
    if (child.code) {
      element = <code key={i}>{element}</code>;
    }

    // Bold
    if (child.bold) {
      element = <strong key={i}>{element}</strong>;
    }

    // Italic
    if (child.italic) {
      element = <em key={i}>{element}</em>;
    }

    // Underline
    if (child.underline) {
      element = <u key={i}>{element}</u>;
    }

    // Strikethrough
    if (child.strikethrough) {
      element = <s key={i}>{element}</s>;
    }

    return element;
  };

  const renderChildren = (children) =>
    children.map((child, i) => {
      if (child.type === "text") {
        return renderTextWithMarks(child, i);
      }

      if (child.type === "link") {
        return (
          <a
            key={i}
            href={child.url}
            target={child.newTab ? "_blank" : "_self"}
            rel="noopener noreferrer"
          >
            {renderChildren(child.children)}
          </a>
        );
      }

      if (child.children) {
        return renderChildren(child.children);
      }

      return null;
    });

  const renderBlock = (block, index) => {
    switch (block.type) {
      case "paragraph":
        return <p key={index}>{renderChildren(block.children)}</p>;

      case "heading": {
        const Tag = `h${block.level || 2}`;
        return <Tag key={index}>{renderChildren(block.children)}</Tag>;
      }

      case "list": {
        if (block.format === "unordered") {
          return (
            <ul key={index}>
              {block.children.map((item, j) => (
                <li key={j}>{renderChildren(item.children)}</li>
              ))}
            </ul>
          );
        }
        if (block.format === "ordered") {
          return (
            <ol key={index}>
              {block.children.map((item, j) => (
                <li key={j}>{renderChildren(item.children)}</li>
              ))}
            </ol>
          );
        }
        return null;
      }

      case "quote":
        return <blockquote key={index}>{renderChildren(block.children)}</blockquote>;

      default:
        return null;
    }
  };

    return <>{typeof content === 'string' ? content : content?.map(renderBlock)}</>;
  } catch (error) {
    console.error(error);
    return null;
  }
};
